"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10.718 4.648a1.5 1.5 0 0 1 2.564 0l6.723 11.073A1.5 1.5 0 0 1 18.723 18H5.277a1.5 1.5 0 0 1-1.282-2.279zM12 13.5a.5.5 0 0 0 .5-.5V8a.5.5 0 1 0-1 0v5a.5.5 0 0 0 .5.5m-.5 2a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
}), 'WarningFilled');
